export const fetchTeamInjuries = async (teamId = 111) => {
  try {
    const res = await fetch(
      `https://statsapi.mlb.com/api/v1/teams/${teamId}/roster?rosterType=injuries`
    );
    if (!res.ok) return [];
    const data = await res.json();
    return data.roster || [];
  } catch {
    return [];
  }
};

export const fetch60DayIL = async (teamId = 111) => {
  try {
    const res = await fetch(
      `https://statsapi.mlb.com/api/v1/teams/${teamId}/roster?rosterType=allDepthCharts`
    );
    if (!res.ok) return [];
    const data = await res.json();
    return (data.roster || []).filter(p =>
      p.status?.description?.toLowerCase().includes('injured') ||
      p.status?.code === 'IL'
    );
  } catch {
    return [];
  }
};